// extracted by mini-css-extract-plugin
export default {"container":"Accordion_container__EMzF0","header":"Accordion_header__Hf-Xn","body":"Accordion_body__fwyjg","removeBottomCornerRadius":"Accordion_removeBottomCornerRadius__aXFtK"};